// extracted by mini-css-extract-plugin
module.exports = {"media-breakpoint-md":"(min-width: 960px)","mediaBreakpointMd":"(min-width: 960px)","content":"MJOpp3BQ"};